import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Communication = lazy(() => import('@feature/communication').then(m => ({ default: m.Communication })));
const Phenomenon = lazy(() => import('@feature/communication').then(m => ({ default: m.Phenomenon })));
const ListAlerts = lazy(() => import('@feature/alerts').then(m => ({ default: m.ListAlerts })));
const CreateForecast = lazy(() => import('@feature/createForecast').then(m => ({ default: m.CreateForecast })));
const CreateMultipleForecast = lazy(() => import('@feature/createMultipleForecast').then(m => ({ default: m.CreateMultipleForecast })));
const CreatePhenomenon = lazy(() => import('@feature/createPhenomenon').then(m => ({ default: m.CreatePhenomenon })));
const CreateDrill = lazy(() => import('@feature/createDrill').then(m => ({ default: m.CreateDrill })));
const AlertDetails = lazy(() => import('@feature/alertDetails').then(m => ({ default: m.AlertDetails })));

import { ROUTES } from '@shared/constants/routes.constants';

export const communicationRoutes: RouteObject[] = [
  {
    path: ROUTES.COMMUNICATION.ROOT,
    element: <Communication />,
  },
  {
    path: ROUTES.COMMUNICATION.LIST_ALERTS,
    element: <ListAlerts />,
  },
  {
    path: ROUTES.COMMUNICATION.LIST_ALERTS_BY_TYPE,
    element: <ListAlerts />,
  },
  {
    path: ROUTES.COMMUNICATION.CREATE_FORECAST,
    element: <CreateForecast />,
  },
  {
    path: ROUTES.COMMUNICATION.CREATE_MULTIPLE_FORECAST,
    element: <CreateMultipleForecast />,
  },
  {
    path: ROUTES.COMMUNICATION.INFO,
    element: <Phenomenon type="info" />,
  },
  {
    path: ROUTES.COMMUNICATION.INFO_TYPES.SECURITY,
    element: <CreatePhenomenon type="security" />,
  },
  {
    path: ROUTES.COMMUNICATION.INFO_TYPES.TRAFFIC,
    element: <CreatePhenomenon type="traffic" />,
  },
  {
    path: ROUTES.COMMUNICATION.INFO_TYPES.GENERAL,
    element: <CreatePhenomenon type="info" />,
  },
  {
    path: ROUTES.COMMUNICATION.NEWS,
    element: <CreatePhenomenon type="news" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON,
    element: <Phenomenon />,
  },

  // Rutas de fenómenos
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.FLOOD,
    element: <CreatePhenomenon type="temp_flood" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.STORM,
    element: <CreatePhenomenon type="storm" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.HAIL,
    element: <CreatePhenomenon type="hail" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.WIND,
    element: <CreatePhenomenon type="wind" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.DRILL,
    element: <CreateDrill />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.FROST,
    element: <CreatePhenomenon type="frost" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.TROPICAL_CYCLONE,
    element: <CreatePhenomenon type="tropical_cyclone" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.FOREST_FIRE,
    element: <CreatePhenomenon type="forest_fire" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.DUST_DEVIL,
    element: <CreatePhenomenon type="dust_devil" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.VOLCANIC,
    element: <CreatePhenomenon type="volcanic" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.LOW_TEMPERATURES,
    element: <CreatePhenomenon type="low_temperatures" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.HIGH_TEMPERATURES,
    element: <CreatePhenomenon type="high_temperatures" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.EARTHQUAKE,
    element: <CreatePhenomenon type="earthquake" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.TSUNAMI,
    element: <CreatePhenomenon type="tsunami" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.ENVIRONMENTAL_RISK,
    element: <CreatePhenomenon type="environmental_risk" />,
  },
  {
    path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.SILENT,
    element: <CreatePhenomenon type="silent" />,
  },
  // Rutas de detalles de alertas
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.FROST,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.TROPICAL_CYCLONE,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.FOREST_FIRE,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.DUST_DEVIL,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.VOLCANIC,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.LOW_TEMPERATURES,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.HIGH_TEMPERATURES,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.EARTHQUAKE,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.TSUNAMI,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.STORM,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.HAIL,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.FLOOD,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.DRILL,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.TEMP_FLOOD,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.WIND,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.INFO,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.NEWS,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.FORECAST,
    element: <AlertDetails />,
  },
  {
    path: ROUTES.COMMUNICATION.ALERT_DETAILS.ENVIRONMENTAL_RISK,
    element: <AlertDetails />,
  },
];
